import * as apiFunction from '@services/apiFunctions'

import { API_URLS } from '@services/apiRoutes'
import { clearsEmptyProperties } from '@utils/functions/clearsEmptyProperties'

import type {
  AddEditAdditionalExpensesRequestProps,
  ApprovalWorkflowOtherExpensesRequestProps,
  EditDetailedSummaryExpensesRequestProps,
  GetAdditionalExpensesRequestProps,
  GetBigNumbersOtherExpensesRequestProps,
  GetDetailedSummaryExpensesRequestProps,
  PreviousOtherExpensesRequestProps,
  RemoveAdditionalExpensesRequestProps,
  ReverseWorkflowOtherExpensesRequestProps
} from './types'

export const reversePreviewOtherExpenses = async (payload: PreviousOtherExpensesRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.otherExpenses}/${payload.filiCode}/reverter-previa-semanal/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const releasePreviewOtherExpenses = async (payload: PreviousOtherExpensesRequestProps) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.otherExpenses}/${payload.filiCode}/liberar-previa-semanal/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const reverseWorkflowOtherExpenses = async (payload: ReverseWorkflowOtherExpensesRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.otherExpenses}/${payload.filiCode}/restaurar-previa/dt-competencia/${payload.competenceDate}`,
    method: 'DELETE'
  })
}

export const approvalWorkflowOtherExpenses = async (payload: ApprovalWorkflowOtherExpensesRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.otherExpenses}/${payload.filiCode}/envio-previa/dt-competencia/${payload.competenceDate}`,
    method: 'PATCH'
  })
}

export const getBigNumbersOtherExpenses = async (payload: GetBigNumbersOtherExpensesRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.otherExpenses}/${payload.filiCode}/detalhe-previa/dt-competencia/${payload.competenceDate}`,
    method: 'GET'
  })
}

export const editDetailedSummaryExpenses = async ({
  routeParams,
  bodyParams
}: EditDetailedSummaryExpensesRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.otherExpenses}/${routeParams.filiCode}/resumo-detalhado`,
    method: 'PUT',
    body
  })
}

export const getDetailedSummaryExpenses = async ({
  routeParams,
  bodyParams
}: GetDetailedSummaryExpensesRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.otherExpenses}/${routeParams.filiCode}/resumo-detalhado`,
    method: 'POST',
    body
  })
}

export const removeAdditionalExpenses = async (payload: RemoveAdditionalExpensesRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.finapi.otherExpenses}/${payload.filiCode}/outras-despesas/${payload.expenseId}`,
    method: 'DELETE'
  })
}

export const editAdditionalExpenses = async ({ routeParams, bodyParams }: AddEditAdditionalExpensesRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.otherExpenses}/${routeParams.filiCode}/outras-despesas/${routeParams.expensesId}`,
    method: 'PUT',
    body
  })
}

export const createAdditionalExpenses = async ({ routeParams, bodyParams }: AddEditAdditionalExpensesRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.otherExpenses}/${routeParams.filiCode}/outras-despesas`,
    method: 'POST',
    body
  })
}

export const getAdditionalExpenses = async ({ routeParams, bodyParams }: GetAdditionalExpensesRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.otherExpenses}/${routeParams.filiCode}/busca-outras-despesas`,
    method: 'POST',
    body
  })
}
